import { observer } from "mobx-react";
import React, { useEffect } from "react";
import instrumentsEquity from "../../assets/images/svg/instrumentsEquity.svg";
import instrumentsFixedIncome from "../../assets/images/svg/instrumentsFixedIncome.svg";
import instrumentsAlternative from "../../assets/images/svg/instrumentsAlternative.svg";
import instrumentsMutual from "../../assets/images/svg/instrumentsMutual.svg";
import QuickDetailsHead from "../QuickDetailsHead/QuickDetailsHead";
import UserStore from "../../store/UserStore";
import AuthStore from "../../store/AuthStore";
import { useLocation, useParams } from "react-router";
import LoadingScreen from "../LoadingScreen/LoadingScreen";
import Header from "../Header/Header";
import BreadCrumb from "../BreadCrumb/BreadCrumb";
import PageTitle from "../PageTitle/PageTitle";

const QuickViewsDetails = observer(({ data }) => {
  const dispImg = {
    2: instrumentsEquity,
    3: instrumentsMutual,
    4: instrumentsFixedIncome,
    5: instrumentsAlternative,
  };

  const { dataId, instuType } = useParams();
  const location = useLocation();

  useEffect(() => {
    const abortController = new AbortController();
    const { signal } = abortController;
    AuthStore.updateLoadingFullScreen(true);
    if (UserStore.isHydrated)
      UserStore.setCurrentQuickView({
        id: dataId,
        type: instuType,
        signal,
      });

    return () => {
      abortController.abort();
    };
  }, [UserStore.isHydrated]);

  return (
    <>
      <PageTitle title={`Instruments ${instuType}`} />
      {!UserStore.isHydrated || AuthStore.isLoadingFullScreen ? (
        <LoadingScreen />
      ) : (
        <>
          <Header type="portfolio" />
          <div className="direct_equity_out_container">
            <BreadCrumb
              locationArr={
                location.pathname === "/portfolio"
                  ? []
                  : UserStore.portfolioPath
              }
              //clickFunction={(index, data) => {}}
              parentName={"portfolio"}
            />
            <div className="quick_view_details_out">
              <div>
                <QuickDetailsHead
                  instrumentName={UserStore?.quickViewDetails?.name}
                  instrumentDetails={UserStore?.quickViewDetails}
                  dispImg={dispImg}
                />
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
});

export default QuickViewsDetails;
